import React, { useEffect } from "react";
import Email from "@/assets/icons/Email";
import Info from "@/assets/icons/Info";
import { Button } from "@/components/shared/Button/Button";
import Title from "@/components/shared/Title/Title";
import { Alert, AlertDescription } from "@/components/ui/alert";
import LayoutOutside from "@/layout/LayoutOutside";
import { useTranslation } from "react-i18next";
import { useVerifyPassword } from "./hooks/useVerifyPassword";
import { useAuth } from "@/auth/Auth";

export function VerifyPassword() {
  const { t } = useTranslation("common");
  const { signOut } = useAuth();
  const { email, timeLeft, isButtonDisabled, handleResendEmail } =
    useVerifyPassword();

  useEffect(() => {
    document.body.classList.add("no-scroll");

    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === "@emailVerified" && e.newValue === "true") {
        if (window.opener) {
          window.opener.close();
        }

        localStorage.setItem("@closeTabs", Date.now().toString());
        localStorage.removeItem("@emailVerified");
      }
    };

    const handleTabClose = (e: StorageEvent) => {
      if (e.key === "@closeTabs") {
        window.close();
      }
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("storage", handleTabClose);

    return () => {
      document.body.classList.remove("no-scroll");
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("storage", handleTabClose);
    };
  }, []);

  return (
    <LayoutOutside
      logout={signOut}
      text={t("backToLogin")}
      classNameMainContainer="h-screen overflow-hidden"
    >
      <section className="text-colorText space-y-8 max-w-[328px] w-full text-center flex flex-col items-center">
        <Email />

        <div className="space-y-5">
          <Title text={t("verifyEmail")} />
          {email && (
            <p className="font-medium text-[#a1a1aa]">
              {t("resetPasswordText")}{" "}
              <strong className="text-colorText">{email}</strong>.
            </p>
          )}
        </div>

        <Button
          variant="link"
          onClick={handleResendEmail}
          disabled={isButtonDisabled}
        >
          {isButtonDisabled ? `${t("resend")} ${timeLeft}` : t("resend")}
        </Button>

        <div className="border-b w-full border-b-colorBorder" />

        <Alert variant="info" className="text-start">
          <Info color="#fafafa" />
          <AlertDescription>{t("resetPasswordSpam")}</AlertDescription>
        </Alert>
      </section>
    </LayoutOutside>
  );
}
